import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unidadeNegocioNome'
})
/** Pipe utilizado para exibir o nome da unidade de negócio concatenando com o nome da linha de produção quando informada */
export class UnidadeNegocioNomePipe implements PipeTransform {
    transform(idUnidadeNegocio: number, nomeUnidadeNegocio: string, idLinhaProducao: number = null, nomeLinhaProducao: string = null): string {
        let nome = '';
        // Unidade de negócio
        nome += idUnidadeNegocio ? nomeUnidadeNegocio : 'SEM UNIDADE DE NEGÓCIO';
        // Linha de produção
        if (idLinhaProducao) {
            if (nome !== '') {
                nome += ' '
            }
            nome += nomeLinhaProducao;
        }

        return nome;
    }
}
